<ion-app>
  <ion-split-pane
    contentId="content"
    *ngIf="
      isLoggedIn &&
      router.url != '/login' &&
      router.url != '/register' &&
      router.url != '/password-reset' &&
      router.url != '/password-reset-password'
    "
  >
    <ion-menu contentId="content" [ngClass]="collapsed ? 'collapsed' : ''">
      <ion-header *ngIf="!collapsed">
        <ion-toolbar class="user-info-container">
          <ion-item class="user-info" lines="none">
            <ion-avatar class="avatar" slot="start">
              <img [src]="profileImg" />
            </ion-avatar>
            <div class="user-name">
              {{ userService.getUser().getFirstName() }}
              {{ userService.getUser().getLastName() }}
              <br />
              <div
                *ngIf="userService.getUser().isAdministrator()"
                class="user-role"
              >
                Administrator
              </div>
            </div>
          </ion-item>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding-top">
        <ng-container *ngIf="!collapsed">
          <ion-item
            routerLink="/bookings"
            (click)="open('/bookings')"
            routerDirection="root"
            [class.active-item]="selectedPath.startsWith('/bookings')"
            lines="none"
            detail="false"
            tappable
          >
            <ion-icon class="menu-icon" name="calendar" slot="start"></ion-icon>
            <ion-label> Bookings </ion-label>
          </ion-item>

          <ion-item
            routerLink="/clients"
            (click)="open('/clients')"
            routerDirection="root"
            [class.active-item]="selectedPath.startsWith('/clients')"
            lines="none"
            detail="false"
            tappable
          >
            <ion-icon
              *ngIf="!collapsed"
              class="menu-icon"
              name="person"
              slot="start"
            ></ion-icon>
            <ion-label *ngIf="!collapsed"> Clients </ion-label>
          </ion-item>

          <ion-item
            routerLink="/requests"
            (click)="open('/requests')"
            routerDirection="root"
            [class.active-item]="selectedPath.startsWith('/requests')"
            lines="none"
            detail="false"
            tappable
          >
            <ion-icon
              *ngIf="!collapsed"
              class="menu-icon"
              name="checkmark"
              slot="start"
            ></ion-icon>
            <ion-label *ngIf="!collapsed"> Requests </ion-label>
            <ion-badge
              slot="end"
              color="danger"
              *ngIf="
                !collapsed && bookingRequestCount && bookingRequestCount > 0
              "
            >
              {{ bookingRequestCount }}
            </ion-badge>
          </ion-item>

          <ion-item
            routerLink="/waitlist"
            (click)="open('/waitlist')"
            routerDirection="root"
            [class.active-item]="selectedPath.startsWith('/waitlist')"
            lines="none"
            detail="false"
            tappable
          >
            <ion-icon
              *ngIf="!collapsed"
              class="menu-icon"
              name="list"
              slot="start"
            ></ion-icon>
            <ion-label *ngIf="!collapsed"> Waitlist </ion-label>
            <ion-badge
              color="danger"
              class="collapsed-badge"
              *ngIf="
                collapsed && bookingWaitListCount && bookingWaitListCount > 0
              "
            >
              {{ bookingWaitListCount }}
            </ion-badge>
            <ion-badge
              slot="end"
              color="danger"
              *ngIf="
                !collapsed && bookingWaitListCount && bookingWaitListCount > 0
              "
            >
              {{ bookingWaitListCount }}
            </ion-badge>
          </ion-item>

          <ion-accordion-group
            *ngFor="let p of pages_2"
            style="background: transparent"
          >
            <ion-accordion
              *ngIf="p.expandable && !p.disabled"
              [class.active-item]="selectedPath.startsWith(p.url)"
              toggleIcon="chevron-down-outline"
              style="background: transparent"
            >
              <ion-item slot="header" class="expandable" lines="none">
                <ion-icon
                  class="menu-icon"
                  name="{{ p.icon }}"
                  slot="start"
                ></ion-icon>
                <ion-label>
                  {{ p.title }}
                </ion-label>
              </ion-item>
              <div slot="content">
                <ion-list>
                  <ion-item
                    class="expanded-item"
                    *ngFor="let child of p.children"
                    (click)="open(child.url)"
                    lines="none"
                    tappable
                  >
                    <div style="margin-left: 38px"></div>
                    <ion-label>{{ child.title }}</ion-label>
                  </ion-item>
                </ion-list>
              </div>
            </ion-accordion>
            <ion-accordion
              *ngIf="
                user &&
                p.url != '/subscribe-to-calendar' &&
                !p.expandable &&
                !p.disabled &&
                !(
                  (user.administrator != 1 &&
                    user.settingsControl != 1 &&
                    p.title == 'Settings') ||
                  (user.administrator != 1 &&
                    user.canViewReports != 1 &&
                    p.title == 'Reports')
                )
              "
              [class.active-item]="selectedPath.startsWith(p.url)"
              [routerLink]="p.url"
              (click)="open(p.url)"
              routerDirection="root"
              toggleIcon=""
              class="no-icon"
              tappable
            >
              <ion-item slot="header" lines="none">
                <ion-icon
                  class="menu-icon"
                  name="{{ p.icon }}"
                  slot="start"
                ></ion-icon>
                <ion-label>
                  {{ p.title }}
                </ion-label>
              </ion-item>
            </ion-accordion>
            <ion-accordion
              *ngIf="
                user &&
                p.url == '/subscribe-to-calendar' &&
                !p.expandable &&
                !p.disabled
              "
              [class.active-item]="selectedPath.startsWith(p.url)"
              (click)="onSubscribeToCalendar()"
              toggleIcon=""
              class="no-icon"
              tappable
            >
              <ion-item slot="header">
                <ion-icon
                  class="menu-icon"
                  name="{{ p.icon }}"
                  slot="start"
                ></ion-icon>
                <ion-label>
                  {{ p.title }}
                </ion-label>
              </ion-item>
            </ion-accordion>
            <ion-accordion *ngIf="p.disabled" toggleIcon="">
              <ion-item slot="header"></ion-item>
            </ion-accordion>
          </ion-accordion-group>

          <ion-item lines="none"></ion-item>
          <ion-item
            tappable
            (click)="onClickHelp()"
            lines="none"
            class="smr-menu-item"
            detail="false"
          >
            <ion-icon
              *ngIf="!collapsed"
              class="menu-icon"
              name="help"
              slot="start"
            ></ion-icon>
            <ion-label *ngIf="!collapsed"> Help </ion-label>
          </ion-item>
          <ion-item lines="none"></ion-item>
          <ion-item
            tappable
            (click)="logout()"
            routerLink="/login"
            routerDirection="root"
            lines="none"
            class="smr-menu-item"
            detail="false"
          >
            <ion-icon
              *ngIf="!collapsed"
              class="menu-icon"
              name="log-out"
              slot="start"
            ></ion-icon>
            <ion-label *ngIf="!collapsed"> Log out </ion-label>
          </ion-item>

          <ion-item
            tappable
            (click)="collapseMenu()"
            lines="none"
            class="smr-menu-item"
            detail="false"
          >
            <ion-label *ngIf="!collapsed">
              <ion-icon
                class="menu-icon"
                name="caret-back-circle-outline"
                slot="start"
              ></ion-icon>
              Collapse menu
            </ion-label>
          </ion-item>
          <ion-item
            (click)="isNativeApp ? null : onReload()"
            class="sm-version-info"
            *ngIf="!collapsed"
            lines="none"
          >
            <ion-icon
              *ngIf="!collapsed && !isNativeApp"
              class="menu-icon"
              name="reload-outline"
              slot="start"
            ></ion-icon>
            <ion-label>Version: {{ appVersion }}</ion-label>
          </ion-item>
        </ng-container>

        <ng-container *ngIf="collapsed">
          <ion-list>
            <ion-menu-toggle auto-hide="false" *ngFor="let p of pages_1">
              <ion-item
                [routerLink]="p.url"
                routerDirection="root"
                [class.active-item]="selectedPath.startsWith(p.url)"
                lines="none"
                detail="false"
                pInputText
                pTooltip="{{ p.title }}"
              >
                <ion-label *ngIf="collapsed">
                  <ion-icon name="{{ p.icon }}" slot="start"></ion-icon>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item
                routerLink="/requests"
                routerDirection="root"
                [class.active-item]="selectedPath.startsWith('/requests')"
                lines="none"
                detail="false"
                pInputText
                pTooltip="Requests"
              >
                <ion-label *ngIf="collapsed" id="requests">
                  <ion-icon name="checkmark" slot="start"></ion-icon>
                </ion-label>
                <ion-badge
                  color="danger"
                  class="collapsed-badge"
                  *ngIf="
                    collapsed && bookingRequestCount && bookingRequestCount > 0
                  "
                >
                  {{ bookingRequestCount }}
                </ion-badge>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle auto-hide="false">
              <ion-item
                routerLink="/waitlist"
                routerDirection="root"
                [class.active-item]="selectedPath.startsWith('/waitlist')"
                lines="none"
                detail="false"
                pInputText
                pTooltip="Waitlist"
              >
                <ion-badge
                  color="danger"
                  class="collapsed-badge"
                  *ngIf="
                    collapsed &&
                    bookingWaitListCount &&
                    bookingWaitListCount > 0
                  "
                >
                  {{ bookingWaitListCount }}
                </ion-badge>
                <ion-label *ngIf="collapsed">
                  <ion-icon name="list" slot="start"></ion-icon>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle auto-hide="false" *ngFor="let p of pages_2">
              <ion-item
                *ngIf="!p.expandable && p.url != '/subscribe-to-calendar'"
                [routerLink]="p.url === null ? null : p.url"
                routerDirection="root"
                [class.active-item]="selectedPath.startsWith(p.url)"
                lines="none"
                [disabled]="p.disabled"
                style="opacity: 1"
                detail="false"
                pInputText
                pTooltip="{{ p.title }}"
              >
                <ion-label *ngIf="collapsed" id="{{ p.icon }}">
                  <ion-icon name="{{ p.icon }}" slot="start"></ion-icon>
                </ion-label>
              </ion-item>
              <ion-item
                *ngIf="!p.expandable && p.url == '/subscribe-to-calendar'"
                (click)="onSubscribeToCalendar()"
                [class.active-item]="selectedPath.startsWith(p.url)"
                lines="none"
                [disabled]="p.disabled"
                style="opacity: 1"
                detail="false"
                pInputText
                pTooltip="{{ p.title }}"
              >
                <ion-label *ngIf="collapsed" id="{{ p.icon }}">
                  <ion-icon name="{{ p.icon }}" slot="start"></ion-icon>
                </ion-label>
              </ion-item>

              <ion-item
                *ngIf="p.expandable"
                routerDirection="root"
                lines="none"
                style="opacity: 1"
                detail="false"
                (click)="popover($event, p)"
                [class.active-item]="selectedPath.startsWith(p.url)"
                tappable
                pInputText
                pTooltip="{{ p.title }}"
              >
                <ion-label>
                  <ion-icon
                    name="{{ p.icon }}"
                    slot="start"
                    id="{{ p.icon }}"
                  ></ion-icon>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-item lines="none"></ion-item>
            <ion-item
              tappable
              (click)="logout()"
              routerLink="/login"
              routerDirection="root"
              lines="none"
              class="smr-menu-item"
              detail="false"
              pInputText
              pTooltip="Log Out"
            >
              <ion-label *ngIf="collapsed">
                <ion-icon name="log-out" slot="start"></ion-icon>
              </ion-label>
            </ion-item>

            <ion-item
              tappable
              (click)="collapseMenu()"
              lines="none"
              class="smr-menu-item"
              detail="false"
            >
              <ion-label *ngIf="collapsed">
                <ion-icon
                  name="caret-forward-circle-outline"
                  slot="start"
                ></ion-icon>
              </ion-label>
            </ion-item>
          </ion-list>
        </ng-container>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="content" main></ion-router-outlet>
  </ion-split-pane>
  <ion-split-pane
    contentId="content"
    *ngIf="
      !isLoggedIn ||
      router.url == '/login' ||
      router.url == '/register' ||
      router.url == '/password-reset' ||
      router.url == '/password-reset-password'
    "
  >
    <ion-router-outlet id="content" main></ion-router-outlet>
  </ion-split-pane>
</ion-app>
